<template>
  <span v-if="info" class="field-info-trigger" @click.stop="showPopup = true">
    <LtIcon name="info" :size="15" />
    <teleport to="body">
      <transition name="fi-fade">
        <div v-if="showPopup" class="field-info-overlay" @click.self="showPopup = false">
          <div class="field-info-popup">
            <div class="field-info-popup__head">
              <h4>{{ info.title }}</h4>
              <button type="button" class="field-info-popup__close" @click="showPopup = false">
                <LtIcon name="close" :size="16" />
              </button>
            </div>
            <p class="field-info-popup__text">{{ info.text }}</p>
            <a v-if="info.file" :href="site_url + info.file.url" :target="info.file.url.endsWith('.pdf') ? '_blank' : undefined" class="field-info-popup__file" download>
              <LtIcon name="download" :size="14" />
              <span>{{ info.file.name }}</span>
            </a>
          </div>
        </div>
      </transition>
    </teleport>
  </span>
</template>

<script>
import LtIcon from './LtIcon.vue';
import { FIELD_INFO } from './fieldInfoConfig.js';

export default {
  name: 'FieldInfo',
  components: { LtIcon },
  props: {
    field: { type: String, required: true },
  },
  data() {
    return { showPopup: false };
  },
  computed: {
    info() {
      return FIELD_INFO[this.field] || null;
    },
  },
};
</script>

<style scoped>
.field-info-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
  color: var(--c-ink-400, #8892a4);
  transition: color 0.15s, background 0.15s;
  vertical-align: middle;
  margin-inline-start: 4px;
}
.field-info-trigger:hover {
  color: var(--c-primary, #6366f1);
  background: var(--c-primary-50, rgba(99, 102, 241, 0.08));
}

.field-info-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  padding: 24px;
}

.field-info-popup {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
  max-width: 420px;
  width: 100%;
  padding: 24px;
  direction: rtl;
  text-align: right;
}

.field-info-popup__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.field-info-popup__head h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--c-ink-900, #1e293b);
}
.field-info-popup__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: var(--c-ink-50, #f1f5f9);
  border-radius: 8px;
  cursor: pointer;
  color: var(--c-ink-500, #64748b);
  transition: background 0.15s;
}
.field-info-popup__close:hover {
  background: var(--c-ink-100, #e2e8f0);
}

.field-info-popup__text {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.7;
  color: var(--c-ink-600, #475569);
}

.field-info-popup__file {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  background: var(--c-primary-50, #eef2ff);
  color: var(--c-primary, #6366f1);
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.15s;
}
.field-info-popup__file:hover {
  background: var(--c-primary-100, #e0e7ff);
}

.fi-fade-enter-active,
.fi-fade-leave-active {
  transition: opacity 0.2s ease;
}
.fi-fade-enter-from,
.fi-fade-leave-to {
  opacity: 0;
}
</style>
